import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import InfScroll from 'modules/listview/web/infScroll.component';
import PostComponent from 'modules/post/web/post.component';
import { View } from 'modules/styled';
import { getPostUrl } from 'app/utils/post';
import { useCommunity } from 'modules/community/community.selectors';

UserPosts.propTypes = {
  pageSize: PropTypes.number,
  load: PropTypes.func,
  match: PropTypes.object,
};

export default function UserPosts({ load, match, pageSize }) {
  // const [postsToRender, setPostsToRender] = useState([]);
  // const [isInfiniteLoading, setIsInfiniteLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const posts = useSelector((state) => state.posts);
  const community = useCommunity();

  if (!community) return null;

  const loadMore = (page, length) => {
    const _hasMore = page * pageSize <= length;
    setHasMore(_hasMore);
    if (_hasMore || length == null) load(length);
  };

  const userId = match.params.id;
  const postIds = posts.userPosts[userId] || [];

  return (
    <InfScroll
      key={`userPosts_ ${community._id}_${userId}`}
      data={postIds}
      loadMore={(p) => loadMore(p, postIds.length)}
      hasMore={hasMore}
    >
      <View sx={{ flexShrink: 1 }}>
        {postIds.map((id) => (
          <UserPost key={id} id={id} community={community} />
        ))}
      </View>
    </InfScroll>
  );
}

UserPost.propTypes = {
  id: PropTypes.string,
  community: PropTypes.object,
};

function UserPost({ id, community }) {
  const posts = useSelector((state) => state.posts);
  const post = posts.posts[id];
  if (!post) return null;
  const repost = post.repost ? posts.posts[post.repost.post] : null;
  const postUser = {
    ...post.embeddedUser,
    _id: post.user,
  };

  let parentPost;
  const parentId = post.parentPost;
  if (parentId) parentPost = posts.posts[parentId];

  const postUrl = getPostUrl(community, post);

  let link = posts.links[post.metaPost];
  if (!link && parentPost) {
    link = posts.links[parentPost.metaPost];
  }

  return (
    <View sx={{ flexShrink: 1 }}>
      <PostComponent
        // {...this.props}
        post={parentPost || post}
        comment={parentPost && post}
        link={{ ...parentPost, ...link }} // TODO - metapost is a pain
        repost={repost}
        postUser={postUser}
        community={community._id}
        postUrl={postUrl}
      />
    </View>
  );
}
